import * as React from 'react'
import {
  MenuItem,
  Menu,
  IconButton,
  Typography,
  Box
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import 'src/i18n/config';
import { useTranslation } from 'react-i18next';

import Languages from 'src/configs/lang';
import ILanguage from 'src/configs/lang/ILanguage';
import { LanguageService } from 'src/services/Language.Service';

/**
 * @function NavBarSliderLanguage
 * @description Combo para la selección de idiomas.
 * @returns {React.JSX.Element}
 * @example <NavBarSliderLanguage key="languagePage" />
 */
function NavBarSliderLanguage(): React.JSX.Element {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const languageConfig: ILanguage = Languages();
  const { i18n } = useTranslation();
  const { setLangOfTheLoguedUser } = LanguageService();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  };

  const handleClose = () => {
    setAnchorEl(null)
  };

  const setLanguage = (lang: string) => {
    // Seteo el dato en la base de datos antes de cambiar el idioma.
    setLangOfTheLoguedUser(lang.toLowerCase()).then(
      (l: string) => {
        i18n.changeLanguage(l);
      }
    ).catch(
      (err) => {
        console.log(err);
      }
    );

    handleClose();
  }

  return (
    <Box component="span" sx={{ paddingRight: { xs: 0.875, md:1 } }}>
      <IconButton
        color="inherit"
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <p style={{ margin: 0, padding: 0, fontSize: '0.9rem' }}>{i18n.language.toUpperCase()} </p>
        <KeyboardArrowDownIcon />
      </IconButton>
      <Menu
        elevation={0}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <>
          {
            languageConfig.list.map((data: { lang: string, name: string }) => (
              <MenuItem
                key={data.lang}
                onClick={
                  (event: React.SyntheticEvent) => {
                    if(event?.preventDefault) event.preventDefault();
                    if(event?.stopPropagation) event.stopPropagation();
                    setLanguage(data.lang);
                  }
                }
                disabled={data.lang === i18n.language}
              >
                <Typography textAlign="center" >
                  <Box fontWeight={data.lang === i18n.language ? "fontWeightBold" : ""} >
                    {data.lang.toUpperCase()} - {data.name}
                  </Box>
                </Typography>
              </MenuItem>
            ))
          }
        </>
      </Menu>
    </Box>
  )
}

export default NavBarSliderLanguage
